import gql from 'graphql-tag'

const deleteProduct = gql`
  mutation ($id: Float!, $workspace_id: Float!) {
    deleteProduct(id: $id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`

export default deleteProduct
